"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapChannelPricingToVod = exports.mapChannelPricingToGql = exports.mapSettingsPricingToVod = exports.mapSettingsPricingToGql = exports.mapVideoPricingToVod = exports.mapVideoPricingToGql = void 0;
var tslib_1 = require("tslib");
var deal_info_types_1 = require("@wix/wix-vod-constants/dist/common/deal-info-types");
var globalTypes_1 = require("../private/generated/globalTypes");
var enum_mapper_1 = require("../utils/enum-mapper");
var videoPricingTypeMapper = new enum_mapper_1.EnumMapper((_a = {},
    _a[globalTypes_1.VideoPricingType.SALE] = deal_info_types_1.DEAL_INFO_TYPES.SALE,
    _a[globalTypes_1.VideoPricingType.RENT] = deal_info_types_1.DEAL_INFO_TYPES.RENT,
    _a));
var channelPricingTypeMapper = new enum_mapper_1.EnumMapper((_b = {},
    _b[globalTypes_1.ChannelPricingType.SUBSCRIPTION] = deal_info_types_1.DEAL_INFO_TYPES.SUBSCRIPTION,
    _b[globalTypes_1.ChannelPricingType.PRICING_PLAN] = deal_info_types_1.DEAL_INFO_TYPES.PLAN,
    _b));
var settingsPricingTypeMapper = new enum_mapper_1.EnumMapper((_c = {},
    _c[globalTypes_1.SettingsDefaultPricingType.SALE] = deal_info_types_1.DEAL_INFO_TYPES.SALE,
    _c[globalTypes_1.SettingsDefaultPricingType.RENT] = deal_info_types_1.DEAL_INFO_TYPES.RENT,
    _c));
function mapPricingToGql(dealInfo) {
    return {
        price: dealInfo.price,
        enabled: dealInfo.enabled,
        period: dealInfo.period || -1,
    };
}
function mapPricingToVod(pricing) {
    return {
        price: pricing.price,
        enabled: pricing.enabled,
        period: pricing.period,
        currency: pricing.currency,
    };
}
function mapVideoPricingToGql(dealInfo) {
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, mapPricingToGql(dealInfo)), { type: videoPricingTypeMapper.toGql(dealInfo.type) });
}
exports.mapVideoPricingToGql = mapVideoPricingToGql;
function mapVideoPricingToVod(pricing) {
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, mapPricingToVod(pricing)), { type: videoPricingTypeMapper.toVod(pricing.type) });
}
exports.mapVideoPricingToVod = mapVideoPricingToVod;
function mapSettingsPricingToGql(dealInfo) {
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, mapPricingToGql(dealInfo)), { type: settingsPricingTypeMapper.toGql(dealInfo.type) });
}
exports.mapSettingsPricingToGql = mapSettingsPricingToGql;
function mapSettingsPricingToVod(pricing) {
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, mapPricingToVod(pricing)), { type: settingsPricingTypeMapper.toVod(pricing.type) });
}
exports.mapSettingsPricingToVod = mapSettingsPricingToVod;
function mapChannelPricingToGql(dealInfo) {
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, mapPricingToGql(dealInfo)), { type: channelPricingTypeMapper.toGql(dealInfo.type), required: dealInfo.required || false });
}
exports.mapChannelPricingToGql = mapChannelPricingToGql;
function mapChannelPricingToVod(pricing) {
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, mapPricingToVod(pricing)), { type: channelPricingTypeMapper.toVod(pricing.type), required: pricing.required });
}
exports.mapChannelPricingToVod = mapChannelPricingToVod;
//# sourceMappingURL=pricing.js.map